import { useMemo } from "react";
import { CUSTOM_FIELD_CATEGORIES, CustomFieldsQuery } from "@/Features";
import { ColumnProps } from "@monolith-forensics/monolith-ui";
import CustomFieldCell from "@/components/Evidence/CustomFieldCell";
import { AcquisitionColumnDefinitions } from "../Definitions";
import { Acquisition } from "../acquisitions.types";

export const useAcquisitionColumnDefinitions = () => {
  const {
    data: customFields,
    isLoading,
    isFetched,
    isSuccess,
    isError,
    refetch,
  } = CustomFieldsQuery.useGetCustomFields({
    category: CUSTOM_FIELD_CATEGORIES.ACQUISITION,
  });

  // Memoized so the Table's columnProps keep a stable identity across renders
  // (column reorder/resize/state churn otherwise) — mirrors
  // useEvidenceColumnDefinitions.
  const columnDefinitions: ColumnProps[] = useMemo(() => {
    if (!customFields) return AcquisitionColumnDefinitions;
    return [
      ...AcquisitionColumnDefinitions,
      ...(customFields.data?.map((field) => ({
        dataField: `custom_field_${field.field_id}`,
        caption: field.field_name,
        visible: false,
        render: ({ rowData }: { rowData: Acquisition }) => {
          // does this custom field have a value?
          if (
            !rowData.custom_attributes?.find(
              (attr) => attr.field_id === field.field_id
            )
          ) {
            return null;
          }
          return <CustomFieldCell rowData={rowData} field={field} />;
        },
      })) ?? []),
    ];
  }, [customFields]);

  return {
    columnDefinitions,
    customFields,
    isLoading,
    isFetched,
    isSuccess,
    isError,
    refetch,
  };
};
